var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{},[_c('h2',[_vm._v("Пробная оплата")]),_vm._v(" "),_c('button',{on:{"click":_vm.testOrder}},[_vm._v("Провести оплату")])])
}
var staticRenderFns = []

export { render, staticRenderFns }